// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dev-roadmap-board {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    flex-wrap: nowrap;
}
.roadmap-column {
    flex: 1 1 33%;
}
.roadmap-column h3, .roadmap-column h4 {
    margin: 0;
}
.roadmap-column ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}
.roadmap-column ul li {
    background-color: #fAFAFA;
    border: 1px solid #EEE;
    padding: 0.5rem;
    margin: 0.5rem 0;
}
[data-theme="dark"] .roadmap-column ul li {
    background-color: #1c2620;
    border-color: #3a463e;
}
.roadmap-column ul li p {
    font-size: 0.9rem;
    margin: 0;
}
.roadmap-item__toggle {
    align-items: flex-start;
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;
    display: flex;
    font: inherit;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 0;
    text-align: left;
    width: 100%;
}
.roadmap-item__toggle:focus-visible {
    outline: 2px solid #316C29;
    outline-offset: 2px;
}
.roadmap-item__title {
    font-size: 0.9rem;
    margin: 0;
}
.roadmap-item__chevron {
    flex: 0 0 auto;
    font-size: 1.15rem;
    line-height: 0.9;
    transition: transform 0.15s ease;
}
.roadmap-item--expanded .roadmap-item__chevron {
    transform: rotate(90deg);
}
.roadmap-item__details {
    border-top: 1px solid #EEE;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
}
.roadmap-column ul li .roadmap-item__description {
    color: #4b5563;
    line-height: 1.4;
    margin-bottom: 0.5rem;
}
[data-theme="dark"] .roadmap-item__details {
    border-top-color: #3a463e;
}
[data-theme="dark"] .roadmap-column ul li .roadmap-item__description {
    color: #b8c5bd;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/DevRoadmapBoard.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;IACI,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,aAAa;IACb,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;AAClB","sourcesContent":[".dev-roadmap-board {\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    flex-wrap: nowrap;\n}\n.roadmap-column {\n    flex: 1 1 33%;\n}\n.roadmap-column h3, .roadmap-column h4 {\n    margin: 0;\n}\n.roadmap-column ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n.roadmap-column ul li {\n    background-color: #fAFAFA;\n    border: 1px solid #EEE;\n    padding: 0.5rem;\n    margin: 0.5rem 0;\n}\n[data-theme=\"dark\"] .roadmap-column ul li {\n    background-color: #1c2620;\n    border-color: #3a463e;\n}\n.roadmap-column ul li p {\n    font-size: 0.9rem;\n    margin: 0;\n}\n.roadmap-item__toggle {\n    align-items: flex-start;\n    background: none;\n    border: 0;\n    color: inherit;\n    cursor: pointer;\n    display: flex;\n    font: inherit;\n    gap: 0.5rem;\n    justify-content: space-between;\n    padding: 0;\n    text-align: left;\n    width: 100%;\n}\n.roadmap-item__toggle:focus-visible {\n    outline: 2px solid #316C29;\n    outline-offset: 2px;\n}\n.roadmap-item__title {\n    font-size: 0.9rem;\n    margin: 0;\n}\n.roadmap-item__chevron {\n    flex: 0 0 auto;\n    font-size: 1.15rem;\n    line-height: 0.9;\n    transition: transform 0.15s ease;\n}\n.roadmap-item--expanded .roadmap-item__chevron {\n    transform: rotate(90deg);\n}\n.roadmap-item__details {\n    border-top: 1px solid #EEE;\n    margin-top: 0.5rem;\n    padding-top: 0.5rem;\n}\n.roadmap-column ul li .roadmap-item__description {\n    color: #4b5563;\n    line-height: 1.4;\n    margin-bottom: 0.5rem;\n}\n[data-theme=\"dark\"] .roadmap-item__details {\n    border-top-color: #3a463e;\n}\n[data-theme=\"dark\"] .roadmap-column ul li .roadmap-item__description {\n    color: #b8c5bd;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
